import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountMovementPayment } from "src/models/Accounting/Accounting.models";

interface AccountMovementPaymentState {
  accountMovementPayments: IAccountMovementPayment[];
  accountMovementPaymentToEdit: IAccountMovementPayment | null;
}

const initialState: AccountMovementPaymentState = {
  accountMovementPayments: [],
  accountMovementPaymentToEdit: null,
};

const AccountMovementPaymentSlice = createSlice({
  name: "AccountMovementPayment",
  initialState,
  reducers: {
    setAccountMovementPaymentList: (
      state,
      action: PayloadAction<IAccountMovementPayment[]>
    ) => {
      state.accountMovementPayments = action.payload;
    },
    setAccountMovementPaymentToEdit: (
      state,
      action: PayloadAction<IAccountMovementPayment | null>
    ) => {
      state.accountMovementPaymentToEdit = action.payload;
    },
    addAccountMovementPayment: (
      state,
      action: PayloadAction<IAccountMovementPayment>
    ) => {
      state.accountMovementPayments.push(action.payload);
    },
    updateAccountMovementPayment: (
      state,
      action: PayloadAction<IAccountMovementPayment>
    ) => {
      let itemIndex = state.accountMovementPayments.findIndex(
        item =>
          item.movementPaymentId ===
          action.payload.movementPaymentId
      );
      if (itemIndex !== -1)
        state.accountMovementPayments[itemIndex] = action.payload;
    },
    deleteAccountMovementPayment: (state, action: PayloadAction<number>) => {
      const newArray = state.accountMovementPayments.filter(
        item => item.movementPaymentId !== action.payload
      );
      state.accountMovementPayments = newArray;
    },
    concatListAccountMovementPayment: (
      state,
      action: PayloadAction<IAccountMovementPayment[]>
    ) => {
      state.accountMovementPayments = [
        ...state.accountMovementPayments.concat(action.payload),
      ];
    },
  },
});

export const {
  setAccountMovementPaymentList,
  setAccountMovementPaymentToEdit,
  addAccountMovementPayment,
  updateAccountMovementPayment,
  deleteAccountMovementPayment,
  concatListAccountMovementPayment,
} = AccountMovementPaymentSlice.actions;

export default AccountMovementPaymentSlice.reducer;
